<template>
  <div>
    <div v-if="infoText" class="col-12">
      <div class="note note-info">
        <p>{{ infoText }}</p>
      </div>
    </div>

    <div v-if="ffmpeg_data" class="form">
      <div class="kt-form__group form-group mt-2">
        <label>Convert to :</label>
        <select v-model="selected" name="file_type" class="form-control">
          <option value="0">
            -- Select Type --
          </option>
          <option v-for="(option, index) in validConversions" :key="index" :value="option">
            {{ option | capitalize }}
          </option>
        </select>
      </div>
      <div class="kt-form__group form-group mt-2">
        <div class="d-flex">
          <ss-checkbox id="create-new-file" v-model="newFileChecked">
            Create New File
          </ss-checkbox>
        </div>
      </div>
      <button type="button" class="btn-convert-file btn btn-ss-standout mt-ladda-btn ladda-button"
              data-style="expand-right"
              @click.prevent="convertFile">
        <span class="ladda-label">Convert File</span>
      </button>
    </div>
  </div>
</template>

<script>
import Ladda from 'ladda';
import 'ladda/dist/ladda-themeless.min.css';

export default {
  name: "FileType",
  filters: {
    capitalize: (value) => {
      if (!value) return '';
      return value.toString().toUpperCase();
    },
  },
  props: {
    item: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    conversionMap: {
      wav: ['mp3', 'm4a'],
      aac: ['mp3', 'm4a'],
      mp3: ['m4a'],
      flac: ['mp3', 'm4a'],
      m4a: ['mp3'],
    },
    selected: 0,
    newFileChecked: 1,
    submitLadda: null,
  }),
  computed: {
    ffmpeg_data() {
      return this.item.ffmpeg_details;
    },
    infoText() {
      if (this.ffmpeg_data) {
      // Retrieve the file type from ffmpeg data
        const format = this.ffmpeg_data.format_name;
        // If we have valid conversions for this file type use them for the select
        if (this.conversionMap[format]) {
          return this.conversionMap[format];
        } else if (format === 'mov,mp4,m4a,3gp,3g2,mj2') {
          return this.conversionMap['m4a'];
        } else {
        // @frank linting errors. computed must return. line below throwing errors
          return `${format} files cannot be converted`;
        }
      }
      return null;
    },
  },
  methods: {
    convertFile() {
      this.submitLadda = Ladda.create(document.querySelector('.btn-convert-file'));
      this.submitLadda.start();
      axios.post(`/api/v1/storage/${window.item.uuid}/convertFileType`, {
        file_type: this.selected,
        new_file: this.newFileChecked,
      }).then((response) => {
        if (response.data) {
          this.$events.fire('reload-waveform');
          if (this.newFileChecked) {
            toastr.success(`Successfully created new ${this.selected} file.`);
          } else {
            toastr.success(`Successfully converted to ${this.selected}.`);
            this.$store.dispatch('reloadData');
            this.selected = 0;
          }
        }
        this.submitLadda.stop();
      }).catch((error) => {
        window.handleAxiosError(error);
        this.submitLadda.stop();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
    .new-file-checkbox {
        margin-top:8px;
    }
</style>
